/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Remove_Group_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Group" |
*
* @param {Team_Manager_Remove_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_group_title = /** @type {((inputs?: Team_Manager_Remove_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить группу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover grupo")
	return /** @type {LocalizedString} */ ("Remove Group")
});